<template>
    <div class="tab-pane" id="addBadge" role="tabpanel">
        <validation-observer ref="registerForm" #default="{ invalid }">
            <b-row>
                <!-- الجزء (1 to 30) -->
                <div class="col-md-12" v-if="!completed">
                    <b-alert variant="warning" show>
                        <div class="alert-body">
                            <i class="fas fa-exclamation-triangle" style="position:relative;top:1px"></i>
                           يرجي اكمال الورد السابق قبل اضافة ورد جديد
                        </div>
                    </b-alert>

                </div>
                <b-col md="6" class="mb-2">
                    <label>الجزء</label>
                    <b-form-select v-model="selectedJuz" :options="juzOptions" :disabled="!completed" />
                </b-col>

                <!-- الورد (1 to 8) -->
                <b-col md="6" class="mb-2">
                    <label>الورد</label>
                    <b-form-select v-model="selectedWird" :options="wirdOptions" :disabled="!completed" />
                </b-col>



                <b-col md="4">
                    <b-form-group>
                        <h5>{{ $t("quran_programs.quran_program_time") }}</h5>
                        <flat-pickr v-model="newData.date" class="form-control" :config="{ dateFormat: 'Y-m-d' }" />
                    </b-form-group>
                </b-col>

                <b-col md="4">
                    <b-form-group>
                        <h5>{{ $t("quran_programs.start_at") }}</h5>
                        <b-form-timepicker v-model="newData.start" locale="ar-EG" />
                    </b-form-group>
                </b-col>

                <b-col lg="4">
                    <b-form-group>
                        <h5>{{ $t("quran_programs.end_at") }}</h5>
                        <b-form-timepicker v-model="newData.end" locale="ar-EG" />
                    </b-form-group>
                </b-col>
            </b-row>

            <hr />

            <b-row>
                <b-col lg="6">
                    <b-button block :disabled="invalid" variant="primary" @click="submit()">
                        <i class="fa fa-plus" /> {{ $t("site.save") }}
                    </b-button>
                </b-col>
                <b-col lg="6">
                    <b-button block @click="goToTable()" variant="success">
                        <i class="fas fa-ban"></i> {{ $t("site.cancel") }}
                    </b-button>
                </b-col>
            </b-row>
        </validation-observer>
    </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import flatPickr from "vue-flatpickr-component";
import controller from "@/Controllers/QuranScheduleDateController";

export default {
    name: "AddQuranProgramForm",
    props: ["newItem"],
    components: {
        ValidationProvider,
        ValidationObserver,
        flatPickr
    },
    async created() {
        await this.checkCompleted();
    },
    data() {
        return {
            controller: new controller(),
            selectedJuz: null,
            selectedWird: null,
            newData: {
                date: null,
                start: null,
                end: null
            },
            completed: false,
            lastWard: null,
            lastJuz: null,

            juzOptions: Array.from({ length: 30 }, (_, i) => ({
                value: i + 1,
                text: `${i + 1}`,
            })),

            wirdOptions: Array.from({ length: 8 }, (_, i) => ({
                value: i + 1,
                text: `${i + 1}`,
            })),

        };
    },

    methods: {
        async goToTable() {
            this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
            this.$parent.$parent.firstTab();
        },

        async submit() {
            const date = this.newData.date;
            const start = this.newData.start;
            const end = this.newData.end;
            const startDatetime = `${date} ${start}`; // "2025-05-15 01:02:00"
            const endDatetime = `${date} ${end}`;
            let alward;
            let period;
            if (!this.completed) {
                alward = this.lastWard;
                period = this.lastJuz;
            } else {
                alward = (this.selectedWird - 1) + (this.selectedJuz - 1) * 8 + 1; // Calculate alward based on selectedJuz and selectedWird
                period = this.selectedJuz; // Period is the selected Juz
            }
            const payload = {
                name: `الورد ${alward} - الجزء ${period}`,
                quran_program_id: this.$route.params.id,
                alward: alward,
                period,
                date: this.newData.date,
                start: startDatetime,
                end: endDatetime,
                type: "general_meeting",
                systemic: 1,
            };

            await this.controller.Insert(payload);



        },

        async checkCompleted() {
            const response = await this.controller.GetAll({
                filter: "quran_program_id|" + this.$route.params.id,
                with: "quranProgram",
            });


            const data = response;
            const notCompleted = data.filter(item => item.complete == 0);

            if (notCompleted.length > 0) {
                this.lastWard = notCompleted[0].alward;
                this.lastJuz = Math.ceil(this.lastWard / 8);
            }
            this.completed = notCompleted.length === 0;

            //allowed periods based on SaveType
            const SaveType = data[0].quran_program.SaveType;
            const StartPeriod = data[0].quran_program.period;
            if (SaveType == "asc") {
                this.juzOptions = this.juzOptions.filter(option => option.value >= StartPeriod);

            } else {
                this.juzOptions = this.juzOptions.filter(option => option.value <= StartPeriod);
            }

        }
    },
};
</script>
